import React from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import $ from "jquery";
import CommonAttachments from "../../../common/attachment/Attachment";
import * as omnimap from "../../../../api/omnimap/omnimapActions";

class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
      media: null
    };

    window.$catalog_budget_detail_context = this;


    this.setMedia = function (media) {
      window.$catalog_budget_detail_context.setState({media: media})
    };

    this.handleModalAttachments = async () => {
      const spin = $("#cover-spin");
      spin.show(0);

      let result = await omnimap.GetMediaListAction(
          { path: "" },
          window.$catalog_budget_selectedRow.identification,
          window.$catalog_management_units_token
      );
      await window.$catalog_budget_detail_context.setMedia(result);
      spin.hide(0);

      $("#wp-catalogus-attachments").modal("show");
    };
  }

  render() {
    return (
      <div id="detailSide">
        <div className="detail-title">Financial in detail</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              id="detail-button"
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/catalog/financial");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              Financial
            </a>
          </div>
          <div className="float-right mt-0">
            <a
              id="edit-button"
              className="button bewerken"
              onClick={() => {
                this.props.history.push(
                  "/catalog/financial/edit/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
            >
              Bewerken
            </a>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Naam</div>
              <div className="box-title-2-active" id="budget-naam">
                {this.state.rowData.naam}
              </div>
              <span className="tooltiptext detail" id="budget-naam-tooltip">
                {this.state.rowData.naam}
              </span>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Code</div>
              <div className="box-title-2" id="budget-code">
                {this.state.rowData.code}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Jaar</div>
              <div className="box-title-2" id="budget-jaar">
                {this.state.rowData.jaar}
              </div>
            </div>
          </div>

        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Omschrijving</div>
              <div className="box-title-2" id="budget-omschrijving"></div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">actief</div>
              <label className="switch">
                <input
                  id="budget-active"
                  type="checkbox"
                  disabled
                  checked={this.state.rowData.isActive ? true : false}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
          <div className="col-lg-2 text-center">
            <div className="box-detail">
              <div className="box-title-1">Bijlage(n)</div>
              <a role="button" onClick={() => this.handleModalAttachments()}>
                <div className="box-title-2 bijlage-ico" id="d-bijlage" />
              </a>
            </div>
          </div>
        </div>
        <CommonAttachments
            media={window.$catalog_budget_detail_context.state.media}
            setMedia={window.$catalog_budget_detail_context.setMedia}
            rowId={window.$catalog_budget_selectedRow.identification}
            contextToReload={window.$catalog_budget_context}
        />
      </div>
    );
  }
}

export default Detail;
